import { compose, prop } from 'ramda';

import { createMatchSelector } from '@/redux/router/selectors';

import { ROUTE_PATH } from './consts';

const getParams = createMatchSelector(ROUTE_PATH);

export const getMerchantId = compose(
  prop('merchantId'),
  prop('params'),
  getParams,
);
